export const toFormModel = (buyer: Buyer) => ({
  oib: undefinedOrNullToEmptyString(buyer.oib),
  name: undefinedOrNullToEmptyString(buyer.name),
  address1: undefinedOrNullToEmptyString(buyer.address1),
  address2: undefinedOrNullToEmptyString(buyer.address2),
  vatId: undefinedOrNullToEmptyString(buyer.vatId),
  code: undefinedOrNullToEmptyString(buyer.code),
  zip: undefinedOrNullToEmptyString(buyer.zip),
  city: undefinedOrNullToEmptyString(buyer.city),
  country: undefinedOrNullToEmptyString(buyer.country),
});

export const fromFormModel = (formModel: BuyerFormModel): Buyer => ({
  oib: emptyStringToUndefined(formModel.oib),
  name: emptyStringToUndefined(formModel.name),
  address1: emptyStringToUndefined(formModel.address1),
  address2: emptyStringToUndefined(formModel.address2),
  vatId: emptyStringToUndefined(formModel.vatId),
  code: emptyStringToUndefined(formModel.code),
  zip: emptyStringToUndefined(formModel.zip),
  city: emptyStringToUndefined(formModel.city),
  country: emptyStringToUndefined(formModel.country),
});

export const toBE = (buyer: BuyerBE): Buyer => ({ ...buyer });
export const fromBE = (buyer: BuyerBE): Buyer => ({ ...buyer });

export const areFormModelsEqual = (first: BuyerFormModel, second: BuyerFormModel): boolean =>
  first.oib === second.oib
  && first.name === second.name
  && first.address1 === second.address1
  && first.address2 === second.address2
  && first.vatId === second.vatId
  && first.code === second.code
  && first.zip === second.zip
  && first.city === second.city
  && first.country === second.country;

export interface BuyerFormModel {
  oib: string;
  name: string;
  address1: string;
  address2: string;
  vatId: string;
  code: string;
  zip: string;
  city: string;
  country: string;
}

export type Buyer = BuyerBE;

export interface BuyerBE {
  oib?: string;
  name?: string;
  address1?: string;
  address2?: string;
  vatId?: string;
  code?: string;
  zip?: string;
  city?: string;
  country?: string;
}

const undefinedOrNullToEmptyString = (value?: string) => (value === undefined || value === null) ? '' : value;

const emptyStringToUndefined = (value?: string) => value === '' ? undefined : value;



// WEBPACK FOOTER //
// ./src/app/shared/model/Buyer.ts